/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecReviewSRPagedResponse
 */
export interface SecReviewSRPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof SecReviewSRPagedResponse
     */
    total: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof SecReviewSRPagedResponse
     */
    results: Array<any>;
    /**
     * 
     * @type {number}
     * @memberof SecReviewSRPagedResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SecReviewSRPagedResponse
     */
    page_size: number;
}

/**
 * Check if a given object implements the SecReviewSRPagedResponse interface.
 */
export function instanceOfSecReviewSRPagedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;

    return isInstance;
}

export function SecReviewSRPagedResponseFromJSON(json: any): SecReviewSRPagedResponse {
    return SecReviewSRPagedResponseFromJSONTyped(json, false);
}

export function SecReviewSRPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewSRPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': json['results'],
        'page': json['page'],
        'page_size': json['page_size'],
    };
}

export function SecReviewSRPagedResponseToJSON(value?: SecReviewSRPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': value.results,
        'page': value.page,
        'page_size': value.page_size,
    };
}

